export default "/packs/images/sprite@2x~cb4b8a282f0ee83b656aa74ce86ea0e5.png";